<template>
    <div>
        <page-header>
            <template #breadcrumbs>
                Регистр ЛРАС <span v-if="!isReadonly && !isEdit">/ Новая запись</span>
                <span v-if="id !== '0' && !isReadonly">/ Редактировать запись</span>
            </template>
            <h2 v-if="id === '0'">
                Создание новой записи
            </h2>
            <h2 v-if="id !== '0' && !isReadonly">Редактирование записи</h2>
        </page-header>
        <ul class="nav nav-tabs nav-justified">
            <li class="nav-item">
                <a class="nav-link" @click.prevent="setActive('general')" :class="{ active: isActive('general') }"
                   href="#general">1. Общая информация</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" @click.prevent="setActive('docs')" :class="{ active: isActive('docs') }"
                   href="#docs">2. Документы</a>
            </li>
        </ul>
        <div class="tab-content py-3" id="myTabContent">
            <div class="tab-pane fade" v-disable-all="isReadonly" :class="{ 'active show': isActive('general') }"
                 id="general">
                <div class="general-info">
                    <h4>Общая информация</h4>
                    <div class="row">
                        <div class="form-group col-3  required">
                            <component-input
                                    placeholder="Введите фамилию"
                                    label="Фамилия" required
                                    v-model="item.surname"
                                    :maxLength="50"/>
                        </div>

                        <div class="form-group col-3 required">
                            <component-input
                                    placeholder="Введите имя"
                                    label="Имя" required
                                    v-model="item.name"
                                    :maxLength="50"/>
                        </div>


                        <div class="form-group col-3">
                            <component-input
                                    placeholder="Введите отчество"
                                    label="Отчество"
                                    v-model="item.patronimic"
                                    :maxLength="50"/>
                        </div>

                        <div class="form-group col-3">
                            <component-input
                                    placeholder="Введите телефон"
                                    label="Телефон"
                                    v-model="item.phone"
                                    :maxLength="50"/>
                        </div>

                        <div class="form-group col-3">
                            <component-input
                                    placeholder="Введите E-mail"
                                    label="E-mail"
                                    v-model="item.email"
                                    :maxLength="50"/>
                        </div>
                    </div>
                    <div class="row">

                        <div class="form-group col-3  required">
                            <label class='control-label'>Пол</label>
                            <Select2 placeholder="Не указано" class="select2" :options="gender" v-model="item.male"/>
                            <div class="invalid-msg" v-if="v$.item.male.$error">Поле обязательно для заполнения</div>
                        </div>

                        <div class="form-group col-3 required">
                            <component-input required
                                             label="СНИЛС"
                                             type="snils"
                                             v-model="item.snils"/>
                        </div>

                    </div>
                </div>
            </div>
            <div class="tab-pane fade" v-disable-all="isReadonly" :class="{ 'active show': isActive('docs') }"
                 id="docs">
                <div class="general-info">
                    <h4>Паспортные данные</h4>
                    <div>
                        <div class="row">
                            <div class="form-group col-2">
                                <component-input label="Серия"
                                                 type="passportSerie"
                                                 v-model="item.passportSerie"
                                />
                            </div>
                            <div class="form-group col-2">
                                <component-input label="Номер"
                                                 type="passportNum"
                                                 v-model="item.passportNum"/>
                            </div>

                            <div class="form-group col-4">
                                <component-input
                                        label="Место выдачи"
                                        v-model="item.passportWhere"
                                        placeholder="Введите место выдачи"/>
                            </div>
                        </div>

                        <div class="row">
                            <div class="form-group col-2">
                                <label class="control-label">Дата выдачи</label>
                                <div>
                                    <date-component :disabled="isReadonly" v-model="item.passportDt"/>
                                </div>
                            </div>

                            <div class="form-group col-2">
                                <component-input label="Код подразделения"
                                                 type="passportDep"
                                                 v-model="item.passportDep"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import API from '../api/representatives'
  import Constants from '../../../common/constants'
  import disableAll from "@/common/directives/disable-all";
  import PageHeader from "../../../common/components/page/PageHeader";
  import ComponentInput from "../../../common/components/ComponentInput";
  import DateComponent from "../../../common/components/DateComponent";
  export default {
    name: "RepresentativeCard",
    components: {DateComponent, ComponentInput, PageHeader},
    directives: {
      'disable-all': disableAll
    },
    data() {
      return {
        id: this.$route.params.id,
        view: this.$route.params.view,
        isReadonly: this.$route.params.action === 'view',
        isEdit: this.$route.params.action === 'edit',
        gender: [{id: true, text: 'Мужчина', value: 1}, {id: false, text: 'Женщина', value: 0}],
        item: {
          male: true
        },
        activeItem: 'general'
      }
    },
    methods: {
      isActive(menuItem) {
        return this.activeItem === menuItem
      },
      setActive(menuItem) {
        this.activeItem = menuItem
      },
      loadPage() {
        if (this.id > 0) {
          API.find(this.id).then(response => {
            this.item = response.data;
          });
        }
      },
      save() {
        this.v$.$touch();

        if (this.v$.$invalid) {
          Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
          return;
        }

        API.save(this.item).then((response) => {
          Constants.alert.fire('Сохранение', response.data.message, response.data.success ? 'success' : 'error');
          if (response.data.success)
            this.$router.push({name: 'Representatives'});
        });
      },
      close() {
        this.$router.push({name: 'Representatives'});
      }
    }
  }
</script>

<style scoped>

</style>